import { Dealer } from 'domains/Dealer';
import React from 'react';
import { Panel } from 'components/AdForm/components/Panel/Panel';
import { GoogleReviewPanel } from 'components/PageWrappers/AdDetails/components/GoogleReviews/GoogleReviewPanel/GoogleReviewPanel';
import { CDN_STATIC_ASSETS } from 'utils';
import * as Styled from 'components/DealerPage/components/ReviewPage/ReviewPage.styled';
import { ISearchPageAds } from 'api/types/searchPageApiTypes';

interface OurStockPageProps {
  dealer: Dealer;
  cdnUrl: string;
  domain: string;
  ads: ISearchPageAds[];
}

function ReviewPage({ dealer }: OurStockPageProps) {
  if (!dealer.googleReview) return null;
  return (
    <Styled.Main>
      <Styled.ReviewWrapper>
        <Panel>
          <GoogleReviewPanel
            title={'Customer Reviews'}
            googleReviews={dealer.googleReview}
            cdnUrl={CDN_STATIC_ASSETS}
            reviewUrl={true}
            numberReviews={5}
          />
        </Panel>
      </Styled.ReviewWrapper>
    </Styled.Main>
  );
}

export default ReviewPage;
